module.exports = "<button ng-click=\"exportPostsConfirmation()\" translate=\"app.export_to_csv\" class=\"button-export\">Export filtered data</button>\n";